import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { PartnerService } from '../services/partner.service';

/**
 * Guard for partner-only routes.
 *
 * Mirrors the user app's hard-refresh strategy: the decision is SYNCHRONOUS and
 * reads `PartnerService.isLoggedIn()` — a signal seeded from the `partner_logged_in`
 * flag in localStorage at service construction. So on a full page reload the route
 * resolves instantly without waiting on a network round-trip (the page can paint
 * immediately). The flag is only a UX hint: a real 401 from any API call still
 * forces a logout + redirect via the HTTP interceptor (`handleSessionTimeout`).
 */
export const partnerAuthGuard: CanActivateFn = () => {
  const partnerService = inject(PartnerService);
  const router = inject(Router);

  // Return a UrlTree (not an imperative navigate) so the router cancels the
  // current navigation and performs the redirect deterministically — no
  // side-effect navigation racing the in-flight guard evaluation.
  return partnerService.isLoggedIn() ? true : router.parseUrl('/');
};
